import React, { useCallback } from 'react';
import { Switch } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import ActionTypes from  "../stateManagement/actions/types";
import { changeDateSplit } from '../stateManagement/actions/report';

const SplitDateSwitch = () => {
    const dispatch = useDispatch();
    const {splitByDay} = useSelector((state) => state.reportReducer);

    // Memoize the toggle handler
    const handleToggleSwithSplitMode = useCallback(() => {
        dispatch(changeDateSplit(!splitByDay, ActionTypes.SWITCH_SPLIT_MODE));
    }, [dispatch, splitByDay]);

    return (
            <Switch
                style={{margin: "1rem auto"}}
                checkedChildren="Split per day"
                unCheckedChildren="Split per day"
                onChange={handleToggleSwithSplitMode}
                checked={splitByDay}
            />
    )
};

export default SplitDateSwitch;